import { cn } from "@repo/ui";

/** Mute / fullscreen / close chips (navbar + in-player): dark glass, white icons, readable on video and light header. */
export const MARKETING_LANDING_VIDEO_PLAYER_OVERLAY_CHIP_CLASSNAME = cn(
	"cursor-pointer",
	"inline-flex size-10 items-center justify-center rounded-full",
	"border border-white/20 bg-black/55 text-white shadow-lg backdrop-blur-md",
	"transition-[background-color,border-color,color,box-shadow,fill,stroke] duration-300 ease-out",
	"[&_svg]:transition-[color,stroke,opacity] [&_svg]:duration-300 [&_svg]:ease-out",
	"hover:bg-black/72 hover:text-white",
	"focus:outline-none focus:ring-2 focus:ring-white/40 focus:ring-offset-2 focus:ring-offset-black/50",
	"dark:border-white/22 dark:bg-black/60 dark:text-white dark:shadow-xl dark:backdrop-blur",
	"dark:hover:bg-black/78 dark:hover:text-white",
	"dark:focus:ring-white/45 dark:focus:ring-offset-black/55",
);

/** Pulse ring border on unmute hint — light site theme. */
export const MARKETING_LANDING_VIDEO_UNMUTE_PULSE_RING_BORDER_LIGHT =
	"rgba(15, 23, 42, 0.5)";

/** Pulse ring border on unmute hint — dark site theme (white ring). */
export const MARKETING_LANDING_VIDEO_UNMUTE_PULSE_RING_BORDER_DARK =
	"rgba(255, 255, 255, 0.58)";

/** Shared layout for unmute `PulseRing` (border colour set per resolved theme in UI). */
export const MARKETING_LANDING_VIDEO_UNMUTE_PULSE_RING_LAYOUT = {
	borderPx: 2,
	durationS: 5.5,
	sizePx: 44,
} as const;

/**
 * Unmute-hint outer button: border + glow — chip keeps its shared glass background;
 * white highlight is `MARKETING_LANDING_VIDEO_UNMUTE_HINT_DISC_CLASSNAME` above it.
 */
export const MARKETING_LANDING_VIDEO_UNMUTE_HINT_FRAME_CLASSNAME = cn(
	"border-neutral-900/45 text-neutral-950 shadow-[0_0_18px_rgba(255,255,255,0.35)]",
	"hover:text-neutral-800",
	"dark:border-neutral-900/50 dark:text-neutral-950",
	"dark:shadow-[0_0_22px_rgba(255,255,255,0.4)]",
	"dark:hover:text-neutral-800",
);

/** White layer between pulse rings (z-0) and icon (z-[2]); pulses opacity over the chip bg. */
export const MARKETING_LANDING_VIDEO_UNMUTE_HINT_DISC_CLASSNAME = cn(
	"pointer-events-none absolute inset-0 z-[1] rounded-full bg-white animate-pulse",
	"motion-reduce:animate-none motion-reduce:opacity-100",
	"border border-neutral-900/40 shadow-[inset_0_0_0_1px_rgba(15,23,42,0.08)]",
	"transition-[background-color,box-shadow,border-color] duration-300 ease-out",
	"dark:bg-white",
	"group-hover:animate-none group-hover:opacity-100",
	"group-hover:bg-neutral-50 group-hover:border-neutral-900/35",
	"dark:group-hover:bg-neutral-50",
);

/** Icon on solid white unmute hint: light edge so the glyph reads cleanly. */
export const MARKETING_LANDING_VIDEO_UNMUTE_HINT_ICON_CLASSNAME = cn(
	"motion-safe:drop-shadow-[0_1px_1px_rgba(15,23,42,0.12)]",
	"dark:motion-safe:drop-shadow-[0_1px_1px_rgba(15,23,42,0.12)]",
	"motion-reduce:drop-shadow-none",
);
